<template>
  <v-container>
    <v-row>
      <v-col cols="10" sm="5" md="3" lg="3" xl="3">
        <v-card>
          <img class="px-2 pt-2" src="../assets/me.jpg" width="100%" />
          <v-card-title class="pt-0 mt-0">Rakesh Sipai</v-card-title>
          <v-card-subtitle class="email">
            <a
              href="mailto:rakeshsipai@gmail.com"
              class="teal--text text--lighten-1"
            >rakeshsipai@gmail.com</a>
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="12" sm="7" md="9" lg="9" xl="9">
        <div class="grey lighten-4 py-5 px-5" style="border-radius: 15px;">
          <p class="ma-0">
            <v-icon
              style="position:relative; top:-5px;"
              class="teal--text text--lighten-1"
            >mdi-format-quote-open</v-icon>
            {{quotes[new Date().getDate()].quote}}
            <v-icon
              style="position:relative; top:-5px;"
              class="teal--text text--lighten-1"
            >mdi-format-quote-close</v-icon>
          </p>
          <i class="teal--text text--lighten-1">{{quotes[new Date().getDate()].by}}</i>
        </div>
        <div>
          <v-btn icon x-large class="ma-4" href="https://twitter.com/rakeshbroz" target="_blank">
            <v-icon color x-large>mdi-twitter</v-icon>
          </v-btn>
          <v-btn
            icon
            x-large
            class="ma-4"
            href="https://www.linkedin.com/in/rakesh-sipai-486560136/"
            target="_blank"
          >
            <v-icon x-large>mdi-linkedin</v-icon>
          </v-btn>
          <v-btn
            icon
            x-large
            class="ma-4"
            href="https://www.instagram.com/raksbro/"
            target="_blank"
          >
            <v-icon x-large>mdi-instagram</v-icon>
          </v-btn>
          <v-btn icon x-large class="ma-4">
            <v-icon x-large>mdi-facebook</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      quotes: [{
        quote: 'Many of life\'s failures are people who did not realize how close they were to success when they gave up.',
        by: 'Thomas A. Edison'
      },
      {
        quote: 'The greatest glory in living lies not in never falling, but in rising every time we fall.',
        by: 'Nelson Mandela'
      },
      {
        quote: 'You have brains in your head. You have feet in your shoes. You can steer yourself any direction you choose.',
        by: 'Dr. Seuss'
      },
      {
        quote: 'The way to get started is to quit talking and begin doing.',
        by: 'Walt Disney'
      },
      {
        quote: 'Success is not final; failure is not fatal: It is the courage to continue that counts.',
        by: 'Winston S. Churchill'
      },
      {
        quote: 'The future belongs to those who believe in the beauty of their dreams.',
        by: 'Eleanor Roosevelt'
      },
      {
        quote: 'Your time is limited, so don\'t waste it living someone else\'s life. Don\'t be trapped by dogma – which is living with the results of other people\'s thinking.',
        by: 'Steve Jobs'
      },
      {
        quote: 'I find that the harder I work, the more luck I seem to have.',
        by: 'Thomas Jefferson'
      },
      {
        quote: 'If you set your goals ridiculously high and it\'s a failure, you will fail above everyone else\'s success.',
        by: 'James Cameron'
      },
      {
        quote: 'You miss 100% of the shots you don\'t take.',
        by: 'Wayne Gretzky'
      },
      {
        quote: 'Always remember that you are absolutely unique. Just like everyone else.',
        by: 'Margaret Mead'
      },
      {
        quote: 'I alone cannot change the world, but I can cast a stone across the water to create many ripples.',
        by: 'Mother Teresa'
      },
      {
        quote: 'You will face many defeats in life, but never let yourself be defeated.',
        by: 'Maya Angelou'
      },
      {
        quote: 'The question isn\'t who is going to let me; it\'s who is going to stop me.',
        by: 'Ayn Rand'
      },
      {
        quote: 'Life is either a daring adventure or nothing at all.',
        by: 'Helen Keller'
      },
      {
        quote: 'If life were predictable it would cease to be life and be without flavor.',
        by: 'Eleanor Roosevelt'
      },
      {
        quote: 'Life is never fair, and perhaps it is a good thing for most of us that it is not.',
        by: 'Oscar Wilde'
      },
      {
        quote: 'The only impossible journey is the one you never begin.',
        by: 'Tony Robbins'
      },
      {
        quote: 'In this life we cannot do great things. We can only do small things with great love.',
        by: 'Mother Teresa'
      },
      {
        quote: 'The purpose of our lives is to be happy.',
        by: 'Dalai Lama'
      },
      {
        quote: 'You only live once, but if you do it right, once is enough.',
        by: 'Mae West'
      },
      {
        quote: 'Keep smiling, because life is a beautiful thing and there\'s so much to smile about.',
        by: 'Marilyn Monroe'
      },
      {
        quote: 'Your time is limited, so don\'t waste it living someone else\'s life. Don\'t be trapped by dogma -- which is living with the results of other people\'s thinking.',
        by: 'Steve Jobs'
      },
      {
        quote: 'Life is trying things to see if they work.',
        by: 'Ray Bradbury'
      },
      {
        quote: 'The secret of success is to do the common thing uncommonly well.',
        by: 'John D. Rockefeller Jr'
      },
      {
        quote: 'Success usually comes to those who are too busy to be looking for it.',
        by: 'Henry David Thoreau'
      },
      {
        quote: 'Dream big and dare to fail.',
        by: 'Norman Vaughan'
      },
      {
        quote: 'You may be disappointed if you fail, but you are doomed if you don\'t try.',
        by: 'Beverly Sills'
      },
      {
        quote: 'It does not matter how slowly you go as long as you do not stop.',
        by: 'Confucius'
      },
      {
        quote: 'When everything seems to be going against you, remember that the airplane takes off against the wind, not with it.',
        by: 'Henry Ford'
      },
      {
        quote: 'Twenty years from now you will be more disappointed by the things that you didn\'t do than by the ones you did do. So, throw off the bowlines, sail away from safe harbor, catch the trade winds in your sails. Explore, Dream, Discover.',
        by: 'Mark Twain'
      },
      {
        quote: 'First, have a definite, clear practical ideal; a goal, an objective. Second, have the necessary means to achieve your ends; wisdom, money, materials, and methods. Third, adjust all your means to that end.',
        by: 'Aristotle'
      }
      ]
    }
  }
}
</script>

<style scoped>
.email a,
.email a:hover {
  text-decoration: none;
}
</style>